export interface UserDetails {
  billingUserId: number;
  blockedAt: string;
  blockReason: string;
  cognitoEnabled: boolean;
  cognitoStatus: string;
  cognitoUserId: string;
  createdAt: string;
  deletedAt: string;
  email: string;
  firstName: string;
  fraudAllowedAt: string;
  fraudBlockedAt: string;
  fraudDescription: Record<string, any>;
  fraudDetectedAt: string;
  fraudReason: string;
  id: string;
  lastName: string;
  note: string;
  phone: string;
  singlePayerAccountNumber: string;
  trackingNumberSource: string;
  trackingNumberUserAccount: string;
  shippingBlocked: boolean;
  chargingBlockedAt: string;
  chargingBlockedReason: string;
  smallPackagesAllowedAt: string | null;
  kycStatus?: 'REQUIRED' | 'STARTED' | 'COMPLETED' | 'FAILED' | null;
  kycVerified?: boolean;
  expeditedShipmentsAllowedAt?: string | null;
}

export enum TransactionType {
  Purchase = 'PURCHASE',
  Deposit = 'DEPOSIT',
  AdminPurchase = 'ADMIN_PURCHASE',
  AdminDeposit = 'ADMIN_DEPOSIT',
  PurchaseAdjustment = 'PURCHASE_ADJUSTMENT',
  DepositAdjustment = 'DEPOSIT_ADJUSTMENT',
  Refund = 'REFUND',
  CreditCodes = 'CREDIT_CODE',
}

export interface RefundTransaction {
  amount: number;
  id: string;
  recordId: string;
}

export interface MemberDTO {
  id: string;
  firstName: string;
  secondName: string;
  phone: string;
  email: string;
  position: string;
  enabled: boolean;
  roles: string[];
  createdAt: string;
  updatedAt: string;
}
